import '../scss/flixx.scss';

// Load Bootstrap init
import {initHelpers} from "./components/helpers.js";
import {initScrollAndView} from "./components/scroll_and_view.js";
import {initBootstrap} from "./components/bootstrap.js";
import {initNavigation} from "./components/navigation.js";
import {initCarousel} from "./components/carousel.js";
import {initFlixxCounter} from "./components/flixx_counter.js";
import {initFlixxHero} from "./components/flixx_hero.js";
import {initFlixxTeam} from "./components/flixx_team.js";
import {initFlixxNews} from "./components/flixx_news.js";
import {initLightbox} from "./components/lightbox.js";


$(document).ready(function () {
  initHelpers();
  initScrollAndView();
  initBootstrap();
  initNavigation();
  initCarousel()
  initFlixxCounter();
  initFlixxTeam();
  initFlixxNews();
  initFlixxHero();
  initLightbox();
});



